const traderjoe = require("./traderjoe");
const pangolin = require("./pangolin");

const TOKEN_SYMBOL_TO_ADDRESS = {
  "WETH.e": "0x49d5c2bdffac6ce2bfdb6640f4f80f226bc10bab",
  WAVAX: "0xb31f66aa3c1e785363f0875a1b74e27b85fd66c7",
  JOE: "0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd",
  "USDC.e": "0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664",
  PNG: "0x60781c2586d68229fde47564546784ab3faca982",
  "WBTC.e": "0x50b7545627a5162f82a992c33b87adc75187b218"
};

const TOKEN_ADDRESS_TO_SYMBOL = Object.entries(TOKEN_SYMBOL_TO_ADDRESS).reduce((prev, curr) => ({
  ...prev,
  [curr[1]]: curr[0]
}), {});

const TOKEN_ADDRESS_TO_DECIMALS = {
  [TOKEN_SYMBOL_TO_ADDRESS["USDC.e"]]: 6,
  [TOKEN_SYMBOL_TO_ADDRESS["WETH.e"]]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.JOE]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.WAVAX]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.PNG]: 18
};

const PREFERRED_SWAP_PATH_TOKEN_ADDRESS = TOKEN_SYMBOL_TO_ADDRESS.WAVAX;
const NATIVE_TOKEN = TOKEN_SYMBOL_TO_ADDRESS.WAVAX;

module.exports = {
  TOKEN_ADDRESS_TO_DECIMALS,
  TOKEN_SYMBOL_TO_ADDRESS,
  TOKEN_ADDRESS_TO_SYMBOL,
  PREFERRED_SWAP_PATH_TOKEN_ADDRESS,
  NATIVE_TOKEN,
  PROTOCOLS: {
    traderjoe,
    pangolin
  }
};
